import settingsParams from '../../settingsParams';
import {
  extractSettingsKeys,
  ViewModelSubscription,
} from '../initViewModelSubscriptions';
import { WidgetViewModelFactory } from '../viewModel';

export type TitleViewModel = {
  title: string;
  titleTagName: string;
};

export const createTitleViewModel: WidgetViewModelFactory<TitleViewModel> = ({
  flowAPI: { settings },
}) => {
  return {
    title: settings.get(settingsParams.titleText),
    titleTagName: settings.get(settingsParams.titleTagName),
  };
};

export const subscribeToTitleViewModel: ViewModelSubscription = ({
  subscribe,
  setViewModel,
  flowAPI,
  getState,
}) => {
  subscribe(
    (state) => ({
      ...extractSettingsKeys(state, ['titleText', 'titleTagName']),
    }),
    () => {
      const titleViewModel = createTitleViewModel({
        flowAPI,
        state: getState(),
      });
      setViewModel({ titleViewModel });
    },
  );
};
